<template>
      <a-row type="flex" justify="space-around" align="middle" class="height-100" >
        <a-col :span="24" :sm="16" :md="14" :lg="10" class="center">
            <a-spin>
              <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
            </a-spin>
        </a-col>
      </a-row>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'Logout',
  mounted() {
    firebase.auth().signOut().then(() => {
      this.$router.push('/login');
    }).catch((err) => {
      this.$message.error('Issue logging out. Try again.')
    });
  }
}
</script>
